import { render } from "./TeachersView.vue?vue&type=template&id=4e34d199&scoped=true"
import script from "./TeachersView.vue?vue&type=script&lang=js"
export * from "./TeachersView.vue?vue&type=script&lang=js"

import "./TeachersView.vue?vue&type=style&index=0&id=4e34d199&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e34d199"]])

export default __exports__